import styled from 'styled-components';

export const containerPanel = styled.div`
	position: relative;
	min-height: 100%;
	width: 100%;
`;
